'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var USER_SESSION = exports.USER_SESSION = 'USER-SESSION';
var USER_DATA = exports.USER_DATA = 'USER_DATA';


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-react-session/dist/constants.js
// module id = 1378
// module chunks = 57